import React from "react";
import Select from "react-select";
import { TRIVVY_VISIBILITY_OPTIONS } from "../data";

// TBV-671: shared privacy picker. Uses the app's standard react-select dropdown
// (the same control as the "How many questions" selector) so the privacy picker
// looks identical in the creation flows and the "Update Privacy" modal.
// `value` is the raw enum string ("ONLY_ME" / "ALL_ADMINS"); `onChange` receives
// the newly-selected enum string.
const VisibilitySelect = ({ value, onChange }) => {
  return (
    <Select
      value={value}
      onChange={(option) => {
        if (option) {
          onChange(option.value);
        }
      }}
      options={TRIVVY_VISIBILITY_OPTIONS}
      clearable={false}
      searchable={false}
      placeholder="Select privacy..."
    />
  );
};

export default VisibilitySelect;
